export const wikiPath = 'wissensspeicher';
